import { __assign } from "tslib";
import { getExternalContext, getPlacementContext, } from 'shared/utils/placement';
import { first } from 'shared/utils/misc';
var URL_REGEX = new RegExp('^https?:\\/\\/');
/**
 * Returns the provided string as-is if it is a
 * valid URL. Returns undefined if it is not.
 */
export var validUrlOrUndefined = function (possibleUrl) {
    return possibleUrl && URL_REGEX.test(possibleUrl) ? possibleUrl : undefined;
};
/**
 * Replace all mustache macros (ie. `{{dsp_name}}`) in a string.
 */
export var replaceMacros = function (input) {
    var context = __assign(__assign({}, getPlacementContext()), getExternalContext());
    var mustacheRegex = /{{([^}]+)}}/g;
    var replacer = function (_, macro) {
        return encodeURIComponent(first(context[macro] || ''));
    };
    return (input
        // `{{context}}` can be used to include all relevant tracking data.
        .replace(/{{context}}/g, function () {
        return 'adapt_id={{deliverable_id}}&cb={{o}}&dsp_advertiser={{dsp_advertiser}}' +
            '&dsp_campaign={{dsp_campaign}}&dsp_creative={{dsp_creative}}&dsp_name={{dsp_name}}&dsp_line={{dsp_line}}' +
            '&g={{geo}}&order_mgmt_id={{order_mgmt_id}}&order_mgmt_name={{order_mgmt_name}}' +
            '&orientation={{orientation}}&platform={{platform}}&size={{size}}&site={{site}}';
    })
        // Replace other possible matches.
        .replace(mustacheRegex, replacer));
};
